export default {
  INVESTOR_PROFILE_ON_FLOW_SHOWED_REPOSITORY: Symbol.for('INVESTOR_PROFILE_ON_FLOW_SHOWED_REPOSITORY'),
  UPDATE_INVESTOR_PROFILE_ON_FLOW_SHOWED_COMMAND: Symbol.for('UPDATE_INVESTOR_PROFILE_ON_FLOW_SHOWED_COMMAND'),
};
